import React from 'react';
import alertIcon from '../../../../assets/images/alert.svg';

/* Alert depicting Attention*/
const AttentionAlert = ({ title, description, classes = '' }) => {
  return (
    <div className={'rounded-md bg-yellow-100 p-4 border mt-2 ' + classes} style={{ borderColor: '#FFB500' }}>
      <div className='flex'>
        <div className='flex-shrink-0'>
          <img className='mt-1' src={alertIcon} alt='alert icon' />
        </div>
        <div className='ml-3'>
          <h3 className='text-base mb-0 font-semibold ' style={{ color: '#916C00' }}>
            {title}
          </h3>
          <div className='text-sm' style={{ color: '#916C00' }}>
            {description}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AttentionAlert;
